<div *ngIf="showHtml" style="display: inline-block;">
    <button
        pButton
        icon="pi pi-download"
        label="Download Invoice"
        [disabled]="!invoice"
        (click)="downloadInvoice()"
    ></button>
</div>